export default __webpack_public_path__ + "static/media/CAPA_EM_BRANCO.de3ea875.webp";